import { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useParams, useNavigate } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import { setCategoria, resetCategorias } from '../../slices/filterSlice'
import Login from '../login/Login'
import MensajeConexion from '../mensajeConexion/MensajeConexion'
import * as categoriaService from '../servicios/arbolCategoriaService'
import * as categoriaScrapService from '../servicios/categoriaScrapService'
import styles from './Categorias.module.css'

const Categorias = () => {
  const { isAuthenticated, cargandoUsuario } = useAuth()
  const [categorias, setCategorias] = useState([])
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { categoria } = useParams()

  useEffect(() => {
    cargarCategorias()
  }, [categoria])

  const cargarCategorias = async () => {
    const { data: categorias } =
      categoria === 'scrap'
        ? await categoriaScrapService.buscarTodosPorScraps(1)
        : await categoriaService.buscarTodos()
    setCategorias(categorias.sort((a, b) => a.descripcion.localeCompare(b.descripcion)))
  }

  const handleClick = (c) => {
    dispatch(resetCategorias())
    dispatch(setCategoria({ id: Number(c.idCategoria), label: c.descripcion }))
    if (categoria === 'scrap') {
      navigate('/Publicaciones', { state: { desdeCategoria: true } })
    } else {
      navigate(`/SubCategorias/${c.idCategoria}/${c.descripcion}`)
    }
  }

  if (cargandoUsuario) return null

  return (
    <>
      {!isAuthenticated ? (
        <>
          <MensajeConexion />
          <Login />
        </>
      ) : (
        <fieldset className={styles.fieldset}>
          <legend>Categorias {categoria === 'scrap' && ' Scrap'}</legend>
          <div className={styles.grid}>
            {categorias.map((c) => (
              <div key={c.idCategoria} className={styles.card} onClick={() => handleClick(c)}>
                <div className={styles.icono}>
                  <i className={`bi ${c.imagen ?? 'bi-tag'}`}></i>
                </div>
                <span className={styles.label}>{c.descripcion}</span>
              </div>
            ))}
          </div>
        </fieldset>
      )}
    </>
  )
}

export default Categorias
